import {mapGetters} from 'vuex';

export default {
    name: 'propertyEstimateItem',
    props: {
        item: null,
        index: null,
    },
    inject: ['$eventBus'],
    computed:{
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),
        isCurrent(){
            return  this.dpp.propertyId == this.item.propertyId;
        },
        getIndex(){
            return this.index;
        }
    },
    methods:{
        openDpp(){
            location.href = this.item.dppUrl;
        },
        removeItem(){
            this.$emit('remove', this.getIndex);
        }
    }
}